export default "__VITE_ASSET__5b7e4bfd__"